const MailTo = "mailto:ams.digitalplaform@tecmasolutions.com?subject=Mail Feedback CRM-lite";
export default MailTo;